import { useMemo } from "react";
import { useDeviceType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { AmenitiesComponentProps } from "./Amenities";

const DESKTOP_MAX_AMENITIES = 8;
const MOBILE_MAX_AMENITIES = 4;
export const useAmenities = ({ amenities = [] }: AmenitiesComponentProps) => {
  const { t } = useI18nContext();

  const { isDesktopAndUp } = useDeviceType();

  const maxAmenitiesToShow = isDesktopAndUp
    ? DESKTOP_MAX_AMENITIES
    : MOBILE_MAX_AMENITIES;
  return useMemo(() => {
    return {
      context: {
        amenitiesToShow: amenities.slice(0, maxAmenitiesToShow),
        amenities: amenities,
        showMoreAmenetiesLink: amenities.length > maxAmenitiesToShow,
      },
      text: {
        title: t("core-hotels.shop.amenities.title"),
        moreAmenities: t("core-hotels.shop.amenities.moreAmenities", {
          count: amenities.length - maxAmenitiesToShow,
        }),
      },
    };
  }, [amenities, maxAmenitiesToShow, t]);
};
